import { PAYMENT_PROVIDER } from 'utils/GeneratedApi';

export const onboardingStepRoutes: Record<string, string> = {
  memberInformation: 'member-information',
  additionalMemberInformation: 'additional-member-information',
  physicalProductInformation: 'physical-product-information',
  memberSettings: 'member-settings',
  newsletterInformation: 'newsletter-information',
};

export const STRIPE_MINIMUM_PAYMENT_AMOUNT = 3;

export const PACKAGE_PURCHASING_PERMISSION_LEVEL = {
  ALLOW: 'allow',
  WARN: 'warn',
  BLOCK: 'block',
};

export const UNALLOWED_PAYMENT_PROVERS_FOR_SUBSCRIPTION_CHANGE: PAYMENT_PROVIDER[] = [
  PAYMENT_PROVIDER.External,
  PAYMENT_PROVIDER.EfakturaAvtalegiroEhf,
];
